module.exports = __webpack_public_path__ + "img/join_bg.c58b1726.jpg";